var file_upload_viewer_default = {
  "fontElementMap": "Hj32n",
  "file_upload_container": "zsnms",
  "file_upload_link": "b4iAA",
  "file_upload_error_container": "_6nI7O",
  "file_upload_file_info": "ZFBNC",
  "file_upload_type_icon": "fDyLt",
  "file_upload_status_icon_container": "mt1lk",
  "file_upload_status_icon": "Upfwy",
  "file_upload_description": "KtuzJ",
  "file_upload_name_container": "-G10u",
  "file_upload_name": "rCyzc",
  "file_upload_extension": "igqGI",
  "file_loader_icon": "_4S6r6",
  "file_upload_icon_frame": "XwbIb",
  "file_upload_icon_background": "-iNii"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
